import { render, staticRenderFns } from "./BankAccountSelect.vue?vue&type=template&id=002d2416&"
import script from "./BankAccountSelect.vue?vue&type=script&lang=ts&"
export * from "./BankAccountSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports